import { ErrorMessage } from 'components/Form/components/ErrorMessage/errormessage.styles';
import styled, {
  css,
  gapSize,
  rem,
  screenMobilePlusAndBigger,
  screenTabletLandscapeAndBigger,
  spacingBase,
  tablet,
} from 'theme';
import boxShadow from 'theme/global/box-shadow';

import { RequiredNotice } from './components/RequiredNotice/required-notice.styles';

export const Form = styled.form<{ grid?: boolean }>`
  .form-buttons-modal {
    flex-direction: column !important;
    padding: ${rem(16)} 0 0 !important;

    ${() =>
      screenMobilePlusAndBigger(css`
        max-width: none !important;
        flex-direction: row !important;
        justify-content: space-between;
        margin: 0 0 -1rem 0 !important;
      `)}
  }

  ${(p) =>
    p.grid &&
    css`
      display: grid;
      grid-row-gap: ${rem(10)};
      align-items: center;
      grid-template-columns: 1fr;

      ${tablet(css`
        grid-template-columns: ${rem(700 * 0.33)} minmax(0, ${rem(700 * 0.67)}) minmax(0, auto);

        ${ErrorMessage},
        .radio-button,
        .checkbox {
          grid-column: 2;
        }

        .full-width {
          grid-column: 1 / span 3;
        }

        .form-button {
          grid-column: 2;
          display: flex;
          margin: ${gapSize(2)} 0;
        }

        ${RequiredNotice} {
          grid-column: 2;
        }
      `)}

      label {
        grid-column: 1;
        padding-right: ${spacingBase};
      }

      .btn-submit,
      .btn-cancel {
        border: ${rem(2)} solid ${p.theme.colors.black};
        box-shadow: ${boxShadow.buttonLight};

        ${screenTabletLandscapeAndBigger(css`
          width: ${rem(150)};
        `)}
      }

      .btn-submit {
        order: 1;
        background-color: ${p.theme.colors.black};
        margin-bottom: ${gapSize(2)};

        ${tablet(css`
          margin-bottom: 0;
          margin-right: ${gapSize(2)};
        `)}
      }

      .btn-cancel {
        order: 2;
        background-color: ${p.theme.colors.white};
        color: ${p.theme.colors.gray900};
      }
    `}
`;

export const FormError = styled('div')`
  color: ${(p) => p.theme.colors.red};
  padding-top: calc(${() => spacingBase} * 2);
`;
